import { useCallback, useEffect, useState } from "react";
import LogoSVG from "./LogoSVG";
import { usePlayback } from "./usePlayback";

const KEY = "kgf-intro-seen";

const waitForFonts = () =>
  Promise.race([
    Promise.all(["500", "700", "800"].map((w) => document.fonts.load(`${w} 100px Montserrat`))),
    new Promise((r) => setTimeout(r, 1500)),
  ]);

const shouldShow = () => {
  try {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    return !sessionStorage.getItem(KEY);
  } catch {
    return false;
  }
};

const SplashPlayer = ({ onDone }) => {
  const pb = usePlayback({ autoplay: false });
  const [leaving, setLeaving] = useState(false);
  const { play, done } = pb;

  useEffect(() => {
    waitForFonts().then(play);
  }, [play]);

  useEffect(() => {
    if (!done) return;
    const id = setTimeout(() => setLeaving(true), 700);
    return () => clearTimeout(id);
  }, [done]);

  useEffect(() => {
    if (!leaving) return;
    const id = setTimeout(onDone, 850);
    return () => clearTimeout(id);
  }, [leaving, onDone]);

  return (
    <div
      data-testid="intro-splash"
      className={`fixed inset-0 z-[200] flex items-center justify-center bg-[var(--forest)] transition-opacity duration-[850ms] ease-out ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <LogoSVG t={pb.t} clock={pb.clock} theme="dark" bg="none" className="w-full max-w-[1500px] h-auto px-4" />
      <button
        data-testid="intro-skip-button"
        onClick={() => setLeaving(true)}
        className="absolute bottom-8 right-8 font-mono text-[11px] tracking-[0.25em] uppercase text-[var(--cream)]/70 hover:text-[var(--cream)] border border-[var(--cream)]/20 hover:border-[var(--cream)]/50 rounded-full px-5 py-2.5 transition-colors duration-300"
      >
        Skip intro
      </button>
    </div>
  );
};

export const IntroSplash = () => {
  const [show, setShow] = useState(shouldShow);
  const done = useCallback(() => {
    try {
      sessionStorage.setItem(KEY, "1");
    } catch {}
    setShow(false);
  }, []);
  return show ? <SplashPlayer onDone={done} /> : null;
};
